module.exports = __webpack_public_path__ + "static/media/1018018.b6925cb6.png";